import { FormItem } from '@framework/form';
import React from 'react';
import { useTreeReferencesContext } from '../../../../../../tree/references/TreeReferencesContext';
import { ExpressionReferenceInput } from '../../../../../expressions/references/input/ExpressionReferenceInput';
import { WidgetType } from '../../../../Widget';

export interface IRepeatableListSelectInputProps {}

/**
 * Permette di selezionare la reference a un widget lista ripetibile.
 */
export function RepeatableListSelectInput(
  props: IRepeatableListSelectInputProps,
) {
  const { references } = useTreeReferencesContext();

  return (
    <FormItem
      name="listReference"
      label="Riferimento lista ripetibile"
      help="Indicare la lista ripetibile collegata al widget di controllo"
    >
      <ExpressionReferenceInput
        width="100%"
        size="large"
        name={`listReference`}
        references={references.filter(
          r => r.widgetType === WidgetType.Repeatable,
        )}
      />
    </FormItem>
  );
}
